enum RankLeg {
  OTHER_LEGS = 0,
  FIRST = 1,
  SECOND = 2,
  THIRD = 3,
}

export default RankLeg;
